import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "search_result" }
const _hoisted_2 = { class: "search_result__product-list" }

import { computed } from "vue";
import ProductCard from "../ProductCard.vue";

import { getContext } from "@/composables/useSearch";


export default /*@__PURE__*/_defineComponent({
  __name: 'SearchResult',
  setup(__props) {

const { searchResult } = getContext();

const products = computed(() => {  
  return searchResult.value?.products || [];
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(products.value, (product, index) => {
        return (_openBlock(), _createBlock(ProductCard, {
          key: index,
          product: product
        }, null, 8, ["product"]))
      }), 128))
    ])
  ]))
}
}

})